// extracted by mini-css-extract-plugin
export default {"card":"styles_card__Lv4j0","disabled":"styles_disabled__fJay+","notAllowed":"styles_notAllowed__KzyCU","icon":"styles_icon__Ebmfu"};